/* ============================================================================
   BRAVORA — UX colección en MÓVIL
   1) Selector de metal GLOBAL en la barra de filtros: un circulo por COLOR visual
      (amarillo / blanco / rosa / mixto). Colapsa 14k+18k (amarillo) y oro blanco+
      platino (blanco). Bucket estable entre idiomas via data-metal-bucket (Liquid).
   2) Puntos de paginación propios (estilo Frank Darling), burdeos, debajo de la
      foto, indicando que hay 2ª foto. Se construyen a mano (el sistema del tema
      no se mostraba).
   Defensivo: si el DOM no coincide, no-op.
   ============================================================================ */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  function isMobile() { return MQ.matches; }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function cards() { return $all('.product-card'); }
  function swatchItems(card) { return $all('.variant-option--swatches .variant-option__swatch', card); }
  function nameOf(li) { return (li.getAttribute('data-swatch-name') || '').trim().toLowerCase(); }

  /* Bucket de color ESTABLE entre idiomas: lo calcula el tema (Liquid) por el HEX
     del swatch y lo escribe en data-metal-bucket -> 'yellow' | 'white' | 'rose' | 'mixed'.
     Independiente del idioma (antes se leia "amarillo/blanco/rosa" del nombre traducido,
     que rompia en /de /fr /it). */
  /* BRAVORA: en móvil el selector de metal muestra SOLO los 3 oros (sin bicolor). */
  var METAL_ORDER = ['yellow', 'white', 'rose'];
  function bucketOf(li) {
    var b = (li.getAttribute('data-metal-bucket') || '').trim().toLowerCase();
    return METAL_ORDER.indexOf(b) >= 0 ? b : null;
  }

  /* ---------- Selector de metal global ---------- */
  function metalsPresent() {
    var found = {};
    cards().forEach(function (card) {
      swatchItems(card).forEach(function (li) {
        var c = bucketOf(li);
        if (c && !found[c]) found[c] = li.querySelector('.swatch');
      });
    });
    return METAL_ORDER
      .filter(function (c) { return found[c]; })
      .map(function (c) { return { canon: c, vis: found[c] }; });
  }

  /* Recolor LIGERO e instantaneo: replica el swap de imagen del tema
     (product-card #updateVariantImages) SIN disparar el fetch de seccion por card
     (que era lo que lo hacia lentisimo y dependiente del hover en desktop).
     Pasos por card: marcar el swatch del metal (checked, sin 'change'), des-ocultar
     SU slide + la siguiente (el cap del tema deja solo 2 visibles), y mover la
     galeria a esa slide con el metodo publico card.previewVariant(mediaId). */
  function applyMetal(target) {
    if (!target) return;
    cards().forEach(function (card) {
      var items = swatchItems(card);
      var chosen = null, fallback = null;
      for (var i = 0; i < items.length; i++) {
        var b = (items[i].getAttribute('data-metal-bucket') || '').toLowerCase();
        if (b !== target.bucket) continue;
        if (!fallback) fallback = items[i];
        if (target.hint) {
          var nm = (items[i].getAttribute('data-swatch-name') || '').toLowerCase();
          if (nm.indexOf(target.hint) < 0) continue;
        }
        chosen = items[i];
        break;
      }
      // platino sin variante "platino" propia -> cae al primer blanco del card.
      if (!chosen) chosen = fallback;
      if (!chosen) return;
      var input = chosen.querySelector('input');
      if (!input) return;
      if (!input.checked) input.checked = true;
      var mid = input.dataset && input.dataset.optionMediaId;
      if (!mid) { try { input.click(); } catch (e) {} return; }
      var slides = card.querySelectorAll('slideshow-slide');
      var selIdx = -1;
      for (var j = 0; j < slides.length; j++) {
        if (slides[j].getAttribute('slide-id') === mid) { selIdx = j; break; }
      }
      if (selIdx < 0) return;
      for (var k = 0; k < slides.length; k++) {
        slides[k].hidden = !(k === selIdx || k === selIdx + 1);
      }
      if (typeof card.previewVariant === 'function') {
        try { card.previewVariant(mid); } catch (e) {}
      }
    });
    setTimeout(enhanceDots, 110);
  }

  /* ---------- Recolor del grid al metal del FILTRO (todas las anchuras) ----------
     Devuelve el target de recolor {bucket, hint} desde un label de metal:
     - BICOLOR (lleva '+' o un oro junto a 'platino'): bucket 'mixed' + hint del oro
       (amarillo/rosa) para elegir la foto bicolor correcta por data-swatch-name.
     - PLATINO solo: mismo color que oro blanco -> bucket 'white' (hint 'platino'
       para preferir la variante platino si existe; si no, cae al primer blanco). */
  function metalTarget(s) {
    s = (s || '').toLowerCase();
    if (!s) return null;
    var hasYel = s.indexOf('amarillo') >= 0 || s.indexOf('yellow') >= 0;
    var hasWhi = s.indexOf('blanco') >= 0 || s.indexOf('white') >= 0;
    var hasRos = s.indexOf('rosa') >= 0 || s.indexOf('rose') >= 0 || s.indexOf('pink') >= 0;
    var hasPla = s.indexOf('platino') >= 0 || s.indexOf('platinum') >= 0;
    var isBicolor = s.indexOf('+') >= 0 || s.indexOf('bicolor') >= 0 || (hasPla && (hasYel || hasRos || hasWhi));
    if (isBicolor) {
      if (hasYel) return { bucket: 'mixed', hint: 'amarillo' };
      if (hasRos) return { bucket: 'mixed', hint: 'rosa' };
      if (hasWhi) return { bucket: 'mixed', hint: 'blanco' };
      return { bucket: 'mixed' };
    }
    if (hasYel) return { bucket: 'yellow' };
    if (hasWhi) return { bucket: 'white' };
    if (hasPla) return { bucket: 'white', hint: 'platino' };
    if (hasRos) return { bucket: 'rose' };
    return null;
  }
  /* metal activo por el LABEL HUMANO del DOM (no por la URL: el value es un GID). */
  function activeMetalTarget() {
    var ch = document.querySelector(
      '.brv-iconfilter__input:checked, input[type="checkbox"][name*="metal" i]:checked'
    );
    if (ch) { var t = metalTarget(ch.getAttribute('aria-label') || ch.value); if (t) return t; }
    var qa = document.querySelector('.brv-quickswatch.is-active');
    if (qa) { var t2 = metalTarget(qa.getAttribute('title') || qa.getAttribute('aria-label')); if (t2) return t2; }
    return null;
  }
  /* expuesto: lo llama el handler de quickswatches de la barra (blocks/filters.liquid) */
  window.brvApplyMetal = function (label) {
    applyMetal(metalTarget(label));
  };
  var rt;
  function scheduleRecolorActive() {
    clearTimeout(rt);
    rt = setTimeout(function () { applyMetal(activeMetalTarget()); }, 120);
  }
  /* Recolor INSTANTANEO al marcar un metal en el drawer. SOLO checkboxes de facet
     (no los radios de variante de las cards, que tambien se llaman "Metal"). */
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || inp.type !== 'checkbox' || !inp.checked) return;
    if (!inp.name || inp.name.toLowerCase().indexOf('metal') < 0) return;
    applyMetal(metalTarget(inp.getAttribute('aria-label') || inp.value));
  }, true);

  function buildSelector() {
    if (!isMobile() || !document.querySelector('.product-grid')) return;
    if (document.getElementById('brv-metal-selector')) return;

    var metals = metalsPresent();
    if (metals.length < 2) return;

    var bar = document.querySelector('.facets-mobile-wrapper') ||
              document.querySelector('.facets-controls-wrapper') ||
              document.querySelector('.facets--horizontal');

    var wrap = document.createElement('div');
    wrap.id = 'brv-metal-selector';
    wrap.className = 'brv-metal-selector';

    metals.forEach(function (m) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'brv-metal-selector__dot';
      btn.setAttribute('aria-label', m.canon);
      if (m.vis) { btn.appendChild(m.vis.cloneNode(true)); }
      btn.addEventListener('click', function () {
        applyMetal({ bucket: m.canon });
        $all('.brv-metal-selector__dot', wrap).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
      wrap.appendChild(btn);
    });

    if (bar) { bar.appendChild(wrap); }
    else { var g = document.querySelector('.product-grid'); g.parentNode.insertBefore(wrap, g); }
  }

  /* ---------- Puntos de paginación propios (FD) ---------- */
  function visibleSlides(scroller) {
    /* Contamos por la senal del cap del tema (hidden + display), NO por aria-hidden:
       el carousel marca aria-hidden="true" en la 2a foto (inactiva) y eso hacia que
       el contador diera 1 -> no se pintaban los puntos. */
    return $all('slideshow-slide', scroller).filter(function (s) {
      return !s.hasAttribute('hidden') &&
        getComputedStyle(s).display !== 'none';
    });
  }

  function buildCardDots(card) {
    var gallery = card.querySelector('.card-gallery');
    var scroller = card.querySelector('slideshow-slides');
    if (!gallery || !scroller) return;
    var slides = visibleSlides(scroller);
    var dots = gallery.parentNode.querySelector('.brv-card-dots');

    // <2 = una sola foto (sin puntos). >2 = el cap del tema (product-card.js) aun no
    // ha reducido a 2 -> esperamos al siguiente tick para no pintar 22 puntos.
    if (slides.length < 2) { if (dots) dots.remove(); return; }
    if (slides.length > 2) return;

    if (!dots || dots.children.length !== slides.length) {
      if (dots) dots.remove();
      dots = document.createElement('div');
      dots.className = 'brv-card-dots';
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('span');
        d.className = 'brv-card-dots__dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(d);
      }
      gallery.insertAdjacentElement('afterend', dots);
    }

    // El listener se ata UNA vez al scroller; re-consulta los puntos VIVOS del DOM en
    // cada scroll (si se reconstruyen, no queda referenciando los viejos -> antes el
    // punto activo no se movia al hacer swipe).
    if (!scroller.__brvDots) {
      var sync = function () {
        var dd = gallery.parentNode.querySelector('.brv-card-dots');
        if (!dd || !dd.children.length) return;
        var w = scroller.clientWidth || 1;
        var idx = Math.round(scroller.scrollLeft / w);
        if (idx < 0) idx = 0;
        if (idx > dd.children.length - 1) idx = dd.children.length - 1;
        for (var i = 0; i < dd.children.length; i++) {
          dd.children[i].classList.toggle('is-active', i === idx);
        }
      };
      scroller.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      scroller.__brvDotsSync = sync;
      scroller.__brvDots = true;
    }
    if (scroller.__brvDotsSync) scroller.__brvDotsSync();
  }

  function enhanceDots() {
    if (!isMobile()) return;
    cards().forEach(buildCardDots);
  }

  /* ---------- arranque + re-render ---------- */
  function init() {
    if (!isMobile()) return;
    buildSelector();
    enhanceDots();
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(init, 150); }

  if (document.readyState !== 'loading') { init(); scheduleRecolorActive(); }
  else document.addEventListener('DOMContentLoaded', function () { init(); scheduleRecolorActive(); });

  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var tg = muts[i].target;
        if (tg && tg.closest && tg.closest('#brv-metal-selector, .brv-card-dots')) return;
      }
      schedule();
      /* tras un re-render del grid (filtro server), reaplicar el metal activo
         a las fotos en todas las anchuras (no solo movil). */
      scheduleRecolorActive();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  if (MQ.addEventListener) MQ.addEventListener('change', init);
})();
